import React, { useEffect, useState } from 'react';

// components

import GAEPList from './GAEPList';
import GAEPMainContent from './GAEPMainContent';
import ExternalSiteModal from '@components/common/modal/ExternalSiteModal';

// hooks

import useGaep from './useGaep';
import useDisclosure from '@hooks/useDisclosure';

function GAEPWebBrokerContainer() {

    const { data, getWebBroker } = useGaep();
    const [ selectedUrl, setSelectedUrl ] = useState<string | null>(null);
    const { isOpen, onOpen, onClose } = useDisclosure(false);

    useEffect(() => {
        document.title = 'GAEP Listing';
        getWebBroker();
    }, []);

    const onHandleClickExternalUrl = (url: string) => {
        setSelectedUrl(url);
        onOpen();
    };

    const onHandleContinueExternalUrl = () => {
        onClose();
        selectedUrl && window.open(selectedUrl);
    };

    if (!data) {
        return null;
    }

    return (
        <>
            <GAEPMainContent titleId='gaep.web_broker.shop_with_a_web_broker' mainContentId='gaep.main_content' mainContentSecondLineId='gaep.main_content.second_line' mainContentThirdLineId='gaep.main_content.third_line' />
            <main className="usa-layout-docs usa-section gi-main-section" id="gaep-ins-company">
                <div className="grid-container gi-grid-container">
                    <GAEPList data={data.data} isInsCompanyMode={false} onHandleClickExternalUrl={onHandleClickExternalUrl} />
                </div>
            </main>
            {
                isOpen &&
                <ExternalSiteModal messageId='gaep.external_url.message' onCancel={close} onContinue={onHandleContinueExternalUrl} />
            }
        </>
    );
}

export default GAEPWebBrokerContainer;